const validations = {
	date: () => import('/data/validation/date'),
};

export default validations;
